import React from "react"

import { useRecoilState, useRecoilValue } from "recoil"
import { sizeState, themeState } from "../recoil-atom"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
  ListPages,
  PageMarks,
  GroupMarks,
  Mark,
  Icon,
} from "../styled-components-openmark"

const Usage = () => {
  const [size, setSize] = useRecoilState(sizeState)

  return (
    <Flex center>
      <div className="usage">
        <Flex>
          <img src="/logoA.png" width="50px" />
          <h2>openmark</h2>
        </Flex>
        <br />
        <ul>
          <li>
            openmark에서 다양한 환경에서 자기만의 동일한 인터넷 시작 환경을
            만드세요.
          </li>
          <li>
            다양한 OS(Windows, macOS, iOS, iPadOS, Android), 그에 따른 다양한
            인터넷 브라우저에서도 같은 환경을 이용할 수 있습니다.
          </li>
          <li>
            또한 개인용, 업무용 등 위치에 따른 메인 계정이 다를 때도 같은 시작
            환경을 이용할 수 있습니다.
          </li>
        </ul>
        <br />
        <br />
        <br />
        <h4>⬤ 언제,어디서나 자주 이용하는 정리된 마크</h4>
        <br />
        <div style={{ boxShadow: "1px 1px 6px -1px #ccc", padding: "10px" }}>
          <img src="/imgs/openmark1.png" width={size.appWidth - 60} />
        </div>
        <br />
        <br />
        <br />
        <h4>⬤ Mobile, Pad, PC 화면 최적화</h4>
        <br />
        <div
          style={{
            width: `${size.pageWidth - 40}px`,
            boxShadow: "1px 1px 6px -1px #ccc",
            padding: "10px",
          }}
        >
          <img src="/imgs/openmark2.png" width={size.pageWidth - 60} />
        </div>
        <br />
        <br />
        <br />
        <h4>⬤ 편집</h4>
        <br />
        <h5>- 추가</h5>
        <div
          style={{
            width: `${size.pageWidth - 40}px`,
            boxShadow: "1px 1px 6px -1px #ccc",
            padding: "10px",
          }}
        >
          <img src="/imgs/openmark3.png" width={size.pageWidth - 60} />
        </div>
        <br />
        <br />
        <h4>- 수정</h4>
        <div
          style={{
            width: `${size.pageWidth - 40}px`,
            boxShadow: "1px 1px 6px -1px #ccc",
            padding: "10px",
          }}
        >
          <img src="/imgs/openmark5.png" width={size.pageWidth - 60} />
        </div>
        <br />
        <br />
        <h4>- 위치바꾸기(Drag and Drop)</h4>
        <div
          style={{
            width: `${size.pageWidth - 40}px`,
            boxShadow: "1px 1px 6px -1px #ccc",
            padding: "10px",
          }}
        >
          <img src="/imgs/openmark4.png" width={size.pageWidth - 60} />
        </div>

        <br />
        <br />
        <br />
        <h4>⬤ 페이지, 그룹으로 마크 정리</h4>
        <br />
        <ul>
          <li>총 4페이지</li>
          <li>페이지 당 최대 4그룹</li>
          <li>그룹 당 최대 12마크</li>
        </ul>
        <br />
      </div>

      <style jsx>{`
        .usage {
          width: ${size.appWidth}px;
          padding: 20px 20px;
        }
      `}</style>
    </Flex>
  )
}

export default Usage
